import type { RenderOutput } from './presets.js';
import { enabledDepthOfField } from './depth-of-field.js';

/** The preview and encoder open the same composition with the same bounded settings. */
export function compositionUrl(origin: string, output: RenderOutput, mapStyle: string,
  timelineDurationSeconds = output.durationSeconds, captureFormat = 'png'): string {
  const url = new URL(origin);
  url.search = '';
  url.hash = '';
  const values = { render: 'video', camera: output.cameraStyle, line: output.lineStyle,
    cameraVersion: String(output.cameraStyleVersion), distance: output.cameraDistance, duration: String(timelineDurationSeconds),
    units: output.unitSystem ?? 'metric', capture: captureFormat, map: mapStyle };
  for (const [key, value] of Object.entries(values)) url.searchParams.set(key, value);
  if (output.hidePlaces) url.searchParams.set('hidePlaces', 'true');
  if (output.placeTitle) url.searchParams.set('placeTitle', JSON.stringify(output.placeTitle));
  if (output.exportRange) url.searchParams.set('exportRange', JSON.stringify(output.exportRange));
  if (output.cameraGimbal !== undefined) url.searchParams.set('gimbal', output.cameraGimbal);
  if (output.cameraAngle !== undefined) url.searchParams.set('angle', String(output.cameraAngle));
  const depthOfField = enabledDepthOfField(output.depthOfField);
  if (depthOfField) url.searchParams.set('depthOfField', JSON.stringify(depthOfField));
  if (output.terrainExaggeration !== undefined) url.searchParams.set('terrain', String(output.terrainExaggeration));
  if (output.presentation) url.searchParams.set('presentation', JSON.stringify(output.presentation));
  if (output.trackAppearance) url.searchParams.set('trackAppearance', JSON.stringify(output.trackAppearance));
  return url.href;
}
